export default "data:image/gif;base64,R0lGODlhEgAMAPABAM0AAP///yH5BAAAAAAALAAAAAASAAwAAAIRhI+py+0PYZi02otz3Lx7XgAAOw=="